import { v4 as uuidv4 } from 'uuid'
import React, { Fragment, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import { routerList } from 'routes/routerList'
import RouteValidator from './RouteValidator'

const NotFound = lazy(() => import('components/layout/NotFound'))

const CustomRoutes = () => (
  <>
    <Routes>
      {routerList.map(({ path, ...props }) => {
        return (
          <Route
            path={path}
            key={uuidv4()}
            exact
            element={<RouteValidator path={path} {...props} />}
          />
        )
      })}
      <Route
        path='*'
        element={<NotFound />}
      />
    </Routes>
  </>
)

export default CustomRoutes
